import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=8c14830c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c14830c"]])

export default __exports__